<!-- Load Type Stats -->
<div class="flex flex-column gap-3">
  <p-accordion [activeIndex]="null">
    <p-accordionTab [header]="loadLogisticsHeader">
      <div *ngFor="let load of loadTypes; let last = last" class="load-type-item">
        <!-- Header - Always visible -->
        <div class="flex align-items-center justify-content-between cursor-pointer p-2 border-round hover:surface-200"
          (click)="load.expanded = !load.expanded">
          <div class="flex align-items-center gap-2">
            <i class="pi" [ngClass]="{'pi-chevron-down': load.expanded, 'pi-chevron-right': !load.expanded}"></i>
            <span>{{load.name}}</span>
          </div>
          <span class="font-bold">{{load.count}}</span>
        </div>

        <!-- Expandable Content -->
        <div class="load-breakdown pl-4 mt-2" *ngIf="load.expanded">
          <div class="flex flex-column border-round mb-4">
            <div class="flex justify-content-between align-items-center p-2 border-round hover:surface-200">
              <i class="pi pi-clock text-600"></i>
              <span class="text-600 hover: cursor-pointer" (click)="viewOrderswithStatus('unassigned', load.name)">Unassigned</span>
              <span>{{load.breakdown.unassigned || 0}}</span>
            </div>
            <p-divider class="ml-6 mr-6"></p-divider>
            <div class="flex justify-content-between align-items-center p-2 border-round hover:surface-200">
              <i class="pi pi-calendar text-primary-600"></i>
              <span class="text-600 hover: cursor-pointer" (click)="viewOrderswithStatus('scheduled', load.name)">Scheduled</span>
              <span>{{load.breakdown.scheduled || 0}}</span>
            </div>
            <p-divider class="ml-6 mr-6"></p-divider>
            <div class="flex justify-content-between align-items-center p-2 border-round hover:surface-200">
              <i class="pi pi-sync text-orange-600"></i>
              <span class="text-600 hover: cursor-pointer" (click)="viewOrderswithStatus('inProgress', load.name)">In Progress</span>
              <span>{{load.breakdown.inProgress || 0}}</span>
            </div>
            <p-divider class="ml-6 mr-6"></p-divider>
            <div class="flex justify-content-between align-items-center p-2 border-round hover:surface-200">
              <i class="pi pi-check-circle text-green-600"></i>
              <span class="text-600 hover: cursor-pointer" (click)="viewOrderswithStatus('delivered', load.name)">Delivered</span>
              <span>{{load.breakdown.delivered || 0}}</span>
            </div>
          </div>
        </div>
        <p-divider *ngIf="!last" styleClass="my-0"></p-divider>
      </div>
    </p-accordionTab>
  </p-accordion>
</div>